export const userDetail_actionType = {
    SET_USER_DETAIL_SUCCESS : 'SET_USER_DETAIL_SUCCESS',
    SET_USER_DETAIL_FAILURE : 'SET_USER_DETAIL_FAILURE',
    GET_USER_DETAIL_SUCCESS : 'GET_USER_DETAIL_SUCCESS',
    GET_USER_DETAIL_FAILURE : 'GET_USER_DETAIL_FAILURE',
    RESET_USER_DETAIL_SUCCESS: 'RESET_USER_DETAIL_SUCCESS'
};